export default __webpack_public_path__ + "static/3p8-toolbar-0938fd6a5d3f35c936cb105fda02ae14.jpg";